// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { validAntennaCode } from 'helpers/regex'

import {
  valueIsRequired,
  valueMustBeWithinMaxLength,
} from 'validators/common'

const validateAntennaCode = (v, error, required) => {
  if (!v && !required) {
    return
  }

  const err = (
    (required && valueIsRequired(v)) ||
    valueMustBeWithinMaxLength(v, 6) ||
    // make sure that the value has length, if it does,
    // make sure it matches the regex for valid legacy radio code
    // otherwise, display the error message
    (!!v && v.match(validAntennaCode) === null && 'Allowed characters are A-Z, 0-9 and *.')
  )

  if (err) {
    error.antennaCode = err
  }
}

export default validateAntennaCode
